import { render, staticRenderFns } from "./InstaWidget.vue?vue&type=template&id=4788ca58&scoped=true"
import script from "./InstaWidget.vue?vue&type=script&lang=js"
export * from "./InstaWidget.vue?vue&type=script&lang=js"
import style0 from "./InstaWidget.vue?vue&type=style&index=0&id=4788ca58&prod&lang=scss"
import style1 from "./InstaWidget.vue?vue&type=style&index=1&id=4788ca58&prod&lang=scss"
import style2 from "./InstaWidget.vue?vue&type=style&index=2&id=4788ca58&prod&lang=scss&scoped=true"
import style3 from "./InstaWidget.vue?vue&type=style&index=3&id=4788ca58&prod&lang=scss"
import style4 from "./InstaWidget.vue?vue&type=style&index=4&id=4788ca58&prod&lang=scss&scoped=true"
import style5 from "./InstaWidget.vue?vue&type=style&index=5&id=4788ca58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788ca58",
  null
  
)

export default component.exports